export default "__VITE_ASSET__BdS_HA0e__"